import { usePaginatedQuery } from 'hooks/usePaginatedQuery'
import { TUserList } from 'shared/types'
import { api } from '..'

export const getUserList = (params?: Record<string, string>) =>
  api
    .get<TUserList>('/v1/users', {
      params,
    })
    .then(({ data }) => data)

export const userListQuery = (params?: Record<string, string>) => ({
  queryFn: () => getUserList(params),
  queryKey: ['users', params],
})

export const useGetUserList = () => usePaginatedQuery(userListQuery)
